// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A5yh","label":"styles_label__Tgcz1"};